import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Box } from '@updater/ui-uds';

export const tooltipStyles = ({
  theme,
}: {
  theme: { colors: { darkBlue: string; white: string } };
}) => css`
  cursor: help;
  position: relative;

  &:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: calc(100% + 0.5rem);
    left: 50%;
    transform: translateX(-50%);
    background-color: ${theme.colors.darkBlue};
    color: ${theme.colors.white};
    padding: 0.5rem 0.75rem;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    white-space: nowrap;
    z-index: 1000;
    pointer-events: none;
  }

  &:hover::before {
    content: '';
    position: absolute;
    bottom: calc(100% + 0.125rem);
    left: 50%;
    transform: translateX(-50%);
    border: 0.25rem solid transparent;
    border-top-color: ${theme.colors.darkBlue};
    z-index: 1000;
    pointer-events: none;
  }
`;

export const CompletedSegment = styled(Box)<{
  widthPct: number;
  hasValidating: boolean;
}>`
  width: ${({ widthPct }) => widthPct}%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.confirmation};
  border-radius: ${({ hasValidating }) =>
    hasValidating ? '0.25rem 0 0 0.25rem' : '0.25rem'};
  ${tooltipStyles}
`;

export const ValidatingSegment = styled(Box)<{
  widthPct: number;
  hasCompleted: boolean;
}>`
  width: ${({ widthPct }) => widthPct}%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.warning};
  border-radius: ${({ hasCompleted }) =>
    hasCompleted ? '0 0.25rem 0.25rem 0' : '0.25rem'};
  ${tooltipStyles}
`;
